/**
 * Created by neo on 02.12.20.
 *
 * Plain TypeScript type - no MobX observables.
 */
import { WeekDayEntryBase, parseWeekDayEntry } from './WeekDayEntry';
import { SubscribedEventEntry, createSubscribedEventEntry } from './SubscribedEventEntry';

export type WeekDayEntrySubscribedEvent = WeekDayEntryBase & {
  type: 'subscribedEvent';
  event: SubscribedEventEntry;
};

export function parseWeekDayEntrySubscribedEvent(json?: any): WeekDayEntrySubscribedEvent {
  return {
    ...parseWeekDayEntry({ ...json, type: 'subscribedEvent' }),
    type: 'subscribedEvent' as const,
    event: createSubscribedEventEntry(json?.event),
  };
}

/** @deprecated Use parseWeekDayEntrySubscribedEvent instead */
export const createWeekDayEntrySubscribedEvent = parseWeekDayEntrySubscribedEvent;
